export default "__VITE_ASSET__B07TZMC2__"